/* Shoppable video — click-to-play + slider controls (arrows/dots). ~1.1KB.
   Video has preload="none" so nothing downloads until the shopper taps play. */
(function () {
  /* ---- click-to-play ---- */
  document.querySelectorAll('[data-sv]').forEach(function (scroller) {
    scroller.addEventListener('click', function (e) {
      var btn = e.target.closest('.sv__play');
      if (!btn) return;
      var card = btn.closest('.sv__card');
      var video = card.querySelector('[data-sv-video]');
      if (!video) return;
      scroller.querySelectorAll('.sv__card.is-playing').forEach(function (other) {
        if (other !== card) {
          other.classList.remove('is-playing');
          var ov = other.querySelector('[data-sv-video]');
          if (ov) { ov.pause(); ov.removeAttribute('controls'); }
        }
      });
      card.classList.add('is-playing');
      video.setAttribute('controls', '');
      video.muted = false;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
  });

  /* ---- autoplay all videos at once (muted) while the section is on screen ---- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion) {
    document.querySelectorAll('[data-sv-scroller]').forEach(function (scroller) {
      var videos = Array.prototype.slice.call(scroller.querySelectorAll('[data-sv-video]'));
      if (!videos.length) return;
      function cardOf(v) { return v.closest('.sv__card'); }

      function playAll() {
        videos.forEach(function (v) {
          var card = cardOf(v);
          // Don't disturb a video the shopper has tapped (unmuted) to watch with sound.
          if (card && card.classList.contains('is-playing') && !v.muted) return;
          if (card) card.classList.add('is-playing');
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        });
      }
      function pauseAll() {
        videos.forEach(function (v) {
          v.pause();
          var card = cardOf(v);
          if (card) card.classList.remove('is-playing');
        });
      }

      // Only autoplay while the section is on screen.
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { playAll(); }
          else { pauseAll(); }
        });
      }, { threshold: 0.25 });
      io.observe(scroller);
    });
  }

  /* ---- slider controls ---- */
  document.querySelectorAll('[data-sv-slider]').forEach(function (root) {
    var scroller = root.querySelector('[data-sv-scroller]');
    var controls = root.querySelector('[data-sv-controls]');
    if (!scroller) return;
    var cards = Array.prototype.slice.call(scroller.children);
    if (!cards.length) return;

    // Nothing to slide — hide the controls entirely.
    if (controls && scroller.scrollWidth <= scroller.clientWidth + 2) {
      controls.style.display = 'none';
      return;
    }

    var prev = root.querySelector('[data-sv-prev]');
    var next = root.querySelector('[data-sv-next]');
    var dotsWrap = root.querySelector('[data-sv-dots]');

    function step() {
      var gap = parseFloat(getComputedStyle(scroller).columnGap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }
    function perView() { return Math.max(1, Math.round(scroller.clientWidth / step())); }
    if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -step() * perView(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: step() * perView(), behavior: 'smooth' }); });

    if (dotsWrap) {
      var dots = cards.map(function (c, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sv__dot';
        b.setAttribute('aria-label', 'Go to item ' + (i + 1));
        b.addEventListener('click', function () { scroller.scrollTo({ left: i * step(), behavior: 'smooth' }); });
        dotsWrap.appendChild(b);
        return b;
      });
      var raf;
      function update() {
        var idx = Math.round(scroller.scrollLeft / step());
        if (idx < 0) idx = 0;
        if (idx > dots.length - 1) idx = dots.length - 1;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
      update();
      scroller.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }, { passive: true });
    }
  });
})();
